<script setup lang="ts">
definePageMeta({
  layout: 'landing',
  smoothScroll: true,
})

const { t } = useI18n()

const { crumbs } = useBreadcrumbs([
  { label: t('label.home'), to: '/' },
  { label: t('page.faq.page_title') },
])

useHead({
  titleTemplate: (chunk) => chunk || 'bookforme',
  title: () => seoTitle(t, 'page.faq.page_title', 'FAQ'),
  meta: [
    { name: 'description', content: 'Find answers to frequently asked questions about bookforme — setup, bookings, billing, and more.' },
    { property: 'og:type', content: 'website' },
    { property: 'og:title', content: () => seoTitle(t, 'page.faq.page_title', 'FAQ') },
    { property: 'og:description', content: 'Everything you need to know about bookforme in one place.' },
    { property: 'og:site_name', content: 'bookforme' },
    { name: 'twitter:card', content: 'summary_large_image' },
  ],
})

const searchQuery = ref('')
</script>

<template>
  <div>
    <CommonBreadcrumbs :items="crumbs" />

    <LandingFaqHero v-model="searchQuery" />
    <LandingFaqSection :search-query="searchQuery" />
  </div>
</template>
